import React, { useEffect, useState } from "react";
import api, { mediaUrl } from "../../lib/api";
import ImageUploader from "./ImageUploader";

export default function ResumeAdmin() {
  const [item, setItem] = useState({ url: "", filename: "", label: "" });
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [savedAt, setSavedAt] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/api/resume");
      if (data?.item) setItem({ url: data.item.url || "", filename: data.item.filename || "", label: data.item.label || "" });
    } catch (e) {
      setError(e?.response?.data?.error || e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!item.url) return setError("Upload a PDF or paste a URL first.");
    setBusy(true); setError(null);
    try {
      await api.put("/api/resume/admin", item);
      setSavedAt(new Date().toLocaleTimeString());
    } catch (e) {
      setError(e?.response?.data?.error || e.message);
    } finally {
      setBusy(false);
    }
  };

  if (loading) return <p className="text-muted">Loading…</p>;

  return (
    <div>
      <div className="admin-head">
        <div>
          <span className="eyebrow">Studio</span>
          <h1 style={{ marginTop: 8 }}>Resume / CV</h1>
        </div>
        <button type="button" className="btn" onClick={save} disabled={busy}>
          {busy ? "Saving…" : "Save"}
        </button>
      </div>

      {error && <p style={{ color: "var(--danger)" }}>{error}</p>}
      {savedAt && <p className="success-msg">Saved at {savedAt}</p>}

      <div className="admin-card" style={{ maxWidth: 720 }}>
        <p style={{ color: "var(--muted)", fontSize: 14 }}>
          Upload a PDF — the public <code>/resume</code> page reads the URL below.
          Replace any time; old files remain on disk but the public view shows
          whichever URL is saved here.
        </p>

        <ImageUploader
          label="Resume PDF"
          accept="application/pdf"
          value={item.url}
          onChange={(u) => setItem((p) => ({ ...p, url: u, filename: (u.split("/").pop() || "") }))}
          hint="Max 12 MB. PDF only."
        />

        <div className="field">
          <label>URL (manual override)</label>
          <input
            className="input"
            value={item.url}
            onChange={(e) => setItem((p) => ({ ...p, url: e.target.value }))}
            placeholder="/uploads/foo.pdf or https://…"
          />
        </div>

        <div className="row">
          <div className="field">
            <label>Filename</label>
            <input className="input" value={item.filename} onChange={(e) => setItem((p) => ({ ...p, filename: e.target.value }))} />
          </div>
          <div className="field">
            <label>Label</label>
            <input className="input" value={item.label} onChange={(e) => setItem((p) => ({ ...p, label: e.target.value }))} placeholder="Resume (English)" />
          </div>
        </div>

        {item.url && (
          <div style={{ marginTop: 16 }}>
            <a className="btn btn--ghost" href={mediaUrl(item.url)} target="_blank" rel="noreferrer noopener">
              Open current PDF
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
